import { TradeTypeEnum, BillIoFlagEnum, UserTypeEnum } from './FmsEnums';

/**
 * 单据类型
 */
export const tradeTypeDs = [
	{
		label: '销售单',
		value: TradeTypeEnum.SALE,
	},
	{
		label: '公交销售单',
		value: TradeTypeEnum.BUS_SALE,
	},
	{
		label: '采购单',
		value: TradeTypeEnum.PURCHASE,
	},
	{
		label: '销售退货单',
		value: TradeTypeEnum.SALE_RETURN,
	},
	{
		label: '公交销退单',
		value: TradeTypeEnum.BUS_SALE_RETURN,
	},
	{
		label: '采购退货单',
		value: TradeTypeEnum.PURCHASE_RETURN,
	},
	// {
	//   label: '采购计划',
	//   value: TradeTypeEnum.PURCHASE_PLAN,
	// },
	// {
	//   label: '销售订单',
	//   value: TradeTypeEnum.SALE_ORDER,
	// },
	// {
	//   label: '预约单',
	//   value: TradeTypeEnum.APPOINTMENT,
	// },
	{
		label: '云修-维修单',
		value: TradeTypeEnum.MAINTENANCE,
	},
	{
		label: '云修-维修退单',
		value: TradeTypeEnum.MAINTENANCE_RETURN,
	},
	// {
	//   label: '派工单',
	//   value: TradeTypeEnum.DISPATCH,
	// },
	{
		label: '结算单',
		value: TradeTypeEnum.SETTLE,
	},
	{
		label: '客户优惠单',
		value: TradeTypeEnum.BILL_FAVORABLE,
	},
	// {
	//   label: '回访单',
	//   value: TradeTypeEnum.RETURN_VISIT,
	// },
	// {
	//   label: '盘库单',
	//   value: TradeTypeEnum.STOCKTAKING,
	// },
	// {
	//   label: '损失',
	//   value: TradeTypeEnum.LOSS,
	// },
	// {
	//   label: '账单抹零',
	//   value: TradeTypeEnum.BILL_DISCOUNT,
	// },
];
export const tradeTypeCreateBillDs = [
	{
		label: '期初应收账单',
		value: TradeTypeEnum.BILL_CREATE_RECEIVABLE,
	},
	{
		label: '期初应付账单',
		value: TradeTypeEnum.BILL_CREATE_PAYABLE,
	},
];

/**
 * 交易对象类型
 */
export const partnerTypeDs = [
	{
		label: '客户',
		value: UserTypeEnum.CUSTOMER,
	},
	{
		label: '供应商',
		value: UserTypeEnum.SUPPLIER,
	},
];

/**
 * 收支类型
 */
export const ioFlagDs = [
	{
		label: '收',
		value: BillIoFlagEnum.IN,
	},
	{
		label: '付',
		value: BillIoFlagEnum.OUT,
	},
];

/**
 * 订单收款状态
 */
export const billStatusDs = [
	{
		label: '初始',
		value: 0,
	},
	{
		label: '已记账',
		value: 1,
	},
	{
		label: '已核销',
		value: 2,
	},
];
/**
 * 账单取消状态
 */
export const billCancelStatusDs = [
	{
		label: '初始',
		value: 0,
	},
	// {
	//   label: '审核中',
	//   value: 1
	// },
	{
		label: '已取消',
		value: 2,
	},
	// {
	//   label: '驳回/失败',
	//   value: 9
	// },
];

/**
 * 操作日志类型
 */
export const logDs = [
	{
		label: '开户',
		value: 'OPEN',
	},
	{
		label: '禁用',
		value: 'DISABLE',
	},
	{
		label: '启用',
		value: 'ENABLE',
	},
	{
		label: '调额',
		value: 'ADJUST',
	},
	{
		label: '调额审核',
		value: 'ADJUST_APPROVAL',
	},
	{
		label: '调额审核通过',
		value: 'ADJUST_APPROVAL_ADJUSTED',
	},
	{
		label: '调额审核撤回',
		value: 'ADJUST_APPROVAL_RETURN',
	},
	{
		label: '调额审核驳回',
		value: 'ADJUST_APPROVAL_REJECTED',
	},
	{
		label: '充值',
		value: 'RECHARGE',
	},
	{
		label: '充值审核',
		value: 'RECHARGE_APPROVAL',
	},
	{
		label: '充值审核通过',
		value: 'RECHARGE_APPROVAL_ADJUSTED',
	},
	{
		label: '充值审核撤回',
		value: 'RECHARGE_APPROVAL_RETURN',
	},
	{
		label: '充值审核驳回',
		value: 'RECHARGE_APPROVAL_REJECTED',
	},

	{
		label: '转入',
		value: 'TRANSFER_IN',
	},
	{
		label: '转出',
		value: 'TRANSFER_OUT',
	},
	{
		label: '平帐',
		value: 'BALANCE',
	},
	{
		label: '更新',
		value: 'UPDATE',
	},
];

/**
 * 全量单据 采购(云修 供应链 客车) 单据类型
 */
export const fullOrderPDs = [
	{
		label: '采购单',
		value: 'trade-type.purchase',
	},
	{
		label: '采购退货单',
		value: 'trade-type.purchase-return',
	},
];

/**
 * 全量单据 销售(云修 客车 供应链) 单据类型
 */
export const fullOrderSDs = [
	{
		label: '销售单',
		value: 'trade-type.sale',
	},
	{
		label: '销售退货单',
		value: 'trade-type.sale-return',
	},
];

/**
 * 全量单据 采购(云修 客车) 单据状态
 */
export const fullOrderStatusPDs = [
	{
		label: '调拨采',
		value: 'purchase.allocation',
	},
	{
		label: '已补单',
		value: 'pur-replenish-status.replenish',
	},
	{
		label: '采购已结算',
		value: 'purchase-status.bill',
	},
	{
		label: '采购已作废',
		value: 'purchase.change',
	},
	{
		label: '已入库',
		value: 'purchase.completely-io',
	},
	{
		label: '采购已开单',
		value: 'purchase-status.create',
	},
	{
		label: '采退已结款',
		value: 'pur-return-status.settle',
	},
	{
		label: '采退已作废',
		value: 'purchase-return.change',
	},
	{
		label: '已出库',
		value: 'purchase-return.stock-io',
	},
	{
		label: '采退已结算',
		value: 'purchase-return.settle',
	},
	{
		label: '采退已开单',
		value: 'purchase-return.create',
	},
];

/**
 * 全量单据 采购(供应链) 单据状态
 */
export const fullOrderScmStatusPDs = [
	{
		label: '调拨采',
		value: 'purchase.allocation',
	},
	{
		label: '未转接',
		value: 'purchase-status.switch',
	},
	{
		label: '已转接',
		value: 'purchase-status.transfer',
	},
	{
		label: '采购已结款',
		value: 'g-purchase-status.settle',
	},
	{
		label: '部分入库',
		value: 'gc-purchase-status.partly-io',
	},
	{
		label: '全部入库',
		value: 'd-purchase-status.completely-io',
	},
	{
		label: '待入库',
		value: 'b-purchase-status.submit',
	},
	{
		label: '采购已开单',
		value: 'a-purchase-status.create',
	},
	{
		label: '采购已结算',
		value: 'f-purchase-status.bill',
	},
	{
		label: '采购已作废',
		value: 'h-purchase-status.cancel',
	},
	{
		label: '驳回待结算',
		value: 'e-purchase-status.reject',
	},
	{
		label: '待出库',
		value: 'b-purchase-return-status.submit',
	},
	{
		label: '采退已结款',
		value: 'f-purchase-return-status.settle',
	},
	{
		label: '已出库',
		value: 'c-purchase-return-status.stock-io',
	},
	{
		label: '采退已结算',
		value: 'e-purchase-return-status.bill',
	},
	{
		label: '采退已开单',
		value: 'a-purchase-return-status.create',
	},
	{
		label: '驳回待结算',
		value: 'd-purchase-return-status.reject',
	},
	{
		label: '采退已作废',
		value: 'g-purchase-return-status.cancel',
	},
];

/**
 * 全量单据 销售(云修 客车) 单据状态
 */
export const fullOrderStatusSDs = [
	{
		label: '调拨销',
		value: 'sale.allocation',
	},
	{
		label: '已出库(补)',
		value: 'sale.end',
	},
	{
		label: '销售已开单(补)',
		value: 'sale.supplement',
	},
	{
		label: '已转接',
		value: 'sale.transfer',
	},
	{
		label: '已补单',
		value: 'sale-replenish-status.replenish',
	},
	{
		label: '销售已结算',
		value: 'sale.settle',
	},
	{
		label: '销售已作废',
		value: 'sale.change',
	},
	{
		label: '已出库',
		value: 'sale.stock-io',
	},
	{
		label: '销退已开单',
		value: 'sale.create',
	},
	{
		label: '销退已结款',
		value: 'sale-return-status.write-off',
	},
	{
		label: '销退已作废',
		value: 'sale-return-status.change',
	},
	{
		label: '已入库',
		value: 'sale-return-status.stock-io',
	},
	{
		label: '销退已结算',
		value: 'sale-return-status.settle',
	},
	{
		label: '销退已开单',
		value: 'sale-return-status.create',
	},
];

/**
 * 全量单据 销售(供应链) 单据状态
 */
export const fullOrderScmStatusSDs = [
	{
		label: '调拨销',
		value: 'sale.allocation',
	},
	{
		label: '销售已结款',
		value: 'e-sale-status.settle',
	},
	{
		label: '全部出库',
		value: 'k-sale-status.completely-io',
	},
	{
		label: '销售已开单',
		value: 'a-sale-status.create',
	},
	{
		label: '销售已结算',
		value: 'd-sale-status.bill',
	},
	{
		label: '待结算',
		value: 'b-sale-status.submit',
	},
	{
		label: '部分出库',
		value: 'j-sale-status.partly-io',
	},
	{
		label: '检验中',
		value: 'sh-sale-status.inspecting',
	},
	{
		label: '检验完成',
		value: 'i-sale-status.inspected',
	},
	{
		label: '销售已作废',
		value: 'l-sale-status.cancel',
	},
	{
		label: '已派工',
		value: 'f-sale-status.dispatch',
	},
	{
		label: '备货中',
		value: 'g-sale-status.preparing',
	},
	{
		label: '驳回待结算',
		value: 'c-sale-status.reject',
	},
	{
		label: '已审核',
		value: 'e-sale-status.reviewed',
	},
	{
		label: '待审核',
		value: 'e-sale-status.be-reviewed',
	},
	{
		label: '销退已开单',
		value: 'a-sale-return-status.create',
	},
	{
		label: '销退已结算',
		value: 'e-sale-return-status.bill',
	},
	{
		label: '待入库',
		value: 'b-sale-return-status.submit',
	},
	{
		label: '销退已结款',
		value: 'f-sale-return-status.settle',
	},
	{
		label: '已入库',
		value: 'c-sale-return-status.stock-io',
	},
	{
		label: '销退已作废',
		value: 'g-sale-return-status.cancel',
	},
	{
		label: '驳回待结算',
		value: 'd-sale-return-status.reject',
	},
];

/**
 * 全量单据 维修(云修 客车) 单据类型
 */
export const fullOrderRDs = [
	{
		label: '维修单',
		value: 'trade-type.sale',
	},
];

/**
 * 全量单据 维修(云修 客车) 单据状态
 */
export const fullOrderStatusRDs = [
	{
		label: '退单已审',
		value: 'maintenance.chargeback approve',
	},
	{
		label: '退单待审',
		value: 'maintenance.chargeback pend',
	},
	{
		label: '审核通过',
		value: 'maintenance.approved',
	},
	{
		label: '审核中',
		value: 'maintenance.under-review',
	},
	{
		label: '已作废',
		value: 'maintenance.change',
	},
	{
		label: '已完工',
		value: 'maintenance.completed',
	},
	{
		label: '已回访',
		value: 'maintenance.return-visit',
	},
	{
		label: '已结款',
		value: 'maintenance.write-off',
	},
	{
		label: '在修',
		value: 'maintenance.underway',
	},
	{
		label: '待修',
		value: 'maintenance.await',
	},
	{
		label: '已转接',
		value: 'maintenance.trans',
	},
	{
		label: '已出库',
		value: 'maintenance.stock-io',
	},
	{
		label: '已结算',
		value: 'maintenance.settle',
	},
	{
		label: '已开单',
		value: 'maintenance.create',
	},
];


/**
 * 全量单据 云创 维修单据状态
 */
export const fullOrderCiStatusRDs = [
	{
		label: '待派单',
		value: 'pending_order',
	},
	{
		label: '已派单',
		value: 'pending_labor',
	},
	{
		label: '待出发',
		value: 'pending_departure',
	},
	{
		label: '已出发',
		value: 'already_departure',
	},
	{
		label: '维修中',
		value: 'in_maintenance',
	},
	{
		label: '待付款',
		value: 'pending_payment',
	},
	{
		label: '待系统审核',
		value: 'pending_system_review',
	},
	{
		label: '系统审核失败',
		value: 'system_review_fail',
	},
	{
		label: '待确认',
		value: 'tobe_confirmed',
	},
	{
		label: '已完成',
		value: 'completed',
	},
	{
		label: '已取消',
		value: 'cancelled',
	},
	{
		label: '退单-待审核',
		value: 'pending_review',
	},
	{
		label: '退单-已开单',
		value: 'billed',
	},
	{
		label: '退单-已入库',
		value: 'in_stock',
	},
	{
		label: '退单-已结算',
		value: 'settled',
	},
];


/**
 * 全量单据 公交销售(客车) 单据类型
 */
export const fullOrderBDs = [
	{
		label: '公交销售单',
		value: 'trade-type.transit-sale',
	},
	{
		label: '公交销退单',
		value: 'trade-type.transit-sreturn',
	},
];

/**
 * 调额审核状态
 */
export const adjustStatus = [
	// {
	// 	label: '初始',
	// 	value: 0
	// },
	{
		label: '审核中',
		value: 1
	},
	{
		label: '审核通过(已调整)',
		value: 2
	},
	{
		label: '撤回',
		value: 3
	},
	{
		label: '审核驳回',
		value: 8
	},
	{
		label: '失败',
		value: 9
	},
]

/**
 * 充值审核状态
 */
export const rechargeStatus = [
	{
		label: '待审核',
		value: 0
	},
	{
		label: '审核通过(已调整)',
		value: 1
	},
	{
		label: '撤回',
		value: 3
	},
	{
		label: '审核驳回',
		value: 8
	},
	{
		label: '失败',
		value: 9
	},
]

/**
 * 发票类型
 */
export const invoiceTypeDs = [
	{
		label: '增值税专用发票',
		value: '增值税专用发票',
	},
	{
		label: '增值税普通发票',
		value: '增值税普通发票',
	},
	{
		label: '增值税电子普通发票',
		value: '增值税电子普通发票',
	},
]

/**
 * 开票状态
 */
export const invoiceStatusDs = [
	{
		label: '未开票',
		value: 1,
	},
	{
		label: '已开票',
		value: 2,
	},
];
